import Lara from '@primevue/themes/lara';
import { definePreset } from '@primeuix/themes';

export const MyPreset = definePreset(Lara, {
    semantic: {
        // primary: {
        //     50: '{indigo.50}',
        //     100: '{indigo.100}',
        //     200: '{indigo.200}',
        //     300: '{indigo.300}',
        //     400: '{indigo.400}',
        //     500: '{indigo.500}',
        //     600: '{indigo.600}',
        //     700: '{indigo.700}',
        //     800: '{indigo.800}',
        //     900: '{indigo.900}',
        //     950: '{indigo.950}'
        // },
        // secondary: {
        //     50: '{gray.50}',
        //     100: '{gray.100}',
        //     200: '{gray.200}',
        //     300: '{gray.300}',
        //     400: '{gray.400}',
        //     500: '{gray.500}',
        //     600: '{gray.600}',
        //     700: '{gray.700}',
        //     800: '{gray.800}',
        //     900: '{gray.900}',
        //     950: '{gray.950}'
        // },
        // success: {
        //     50: '{emerald.50}',
        //     100: '{emerald.100}',
        //     200: '{emerald.200}',
        //     300: '{emerald.300}',
        //     400: '{emerald.400}',
        //     500: '{emerald.500}',
        //     600: '{emerald.600}',
        //     700: '{emerald.700}',
        //     800: '{emerald.800}',
        //     900: '{emerald.900}',
        //     950: '{emerald.950}'
        // },
        // info: {
        //     50: '{sky.50}',
        //     100: '{sky.100}',
        //     200: '{sky.200}',
        //     300: '{sky.300}',
        //     400: '{sky.400}',
        //     500: '{sky.500}',
        //     600: '{sky.600}',
        //     700: '{sky.700}',
        //     800: '{sky.800}',
        //     900: '{sky.900}',
        //     950: '{sky.950}'
        // },
        // warning: {
        //     50: '{amber.50}',
        //     100: '{amber.100}',
        //     200: '{amber.200}',
        //     300: '{amber.300}',
        //     400: '{amber.400}',
        //     500: '{amber.500}',
        //     600: '{amber.600}',
        //     700: '{amber.700}',
        //     800: '{amber.800}',
        //     900: '{amber.900}',
        //     950: '{amber.950}'
        // },
        // error: {
        //     50: '{rose.50}',
        //     100: '{rose.100}',
        //     200: '{rose.200}',
        //     300: '{rose.300}',
        //     400: '{rose.400}',
        //     500: '{rose.500}',
        //     600: '{rose.600}',
        //     700: '{rose.700}',
        //     800: '{rose.800}',
        //     900: '{rose.900}',
        //     950: '{rose.950}'
        // }
    }
});
